import { IconButton } from "@material-ui/core";
import React from "react";
import i18next from "../../../assets/i18n/i18n";
import itsmeLogoBtn from "../../../assets/images/png/itsmeLogoBtn.png";
import { getItsmeLoginUrl } from "../../../utils/urlProvider";

type Props = {
    spFull: string;
    acs: string;
};

const ButtonLoginWithItsme = ({ spFull, acs }: Props): React.ReactElement => {
    const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();
        window.location.href = getItsmeLoginUrl(spFull, acs);
    };
    return (
        <IconButton id="BtnLinkAccount" className="btn primary-btn max-width" onClick={handleClick}>
            <img src={itsmeLogoBtn} alt="itsme logo btn" />
            <p className="btn-label link-account-btn-label">{i18next.t("Buttons.LoginWithItsme")}</p>
        </IconButton>
    );
};

export default ButtonLoginWithItsme;
